export const ViewType = {
  image: "image",
  pdf: "pdf",
};
